module.exports = __webpack_public_path__ + "static/media/job_category_3.6dae6c43.png";